import { getPropsForClickTracking } from "../../utils/tracking";
import { itemCardLabel } from "../../utils/label";

<if(input.model)>
  $ const { model, locality, localizedContent, watchInstance, handleWatchListItemToggle, watchListItems } = input;
  $ const {
    card,
    sponsored,
    signalling,
    previewCardAction: action,
    hotnessSignal,
    productRating,
    sellerName,
    sellerRating,
    listingFormat,
  } = model;
  $ const { title, image, displayPrice } = card;
  $ const { itemCardNavigationAction, itemCardCloseAction, sellerListingCountLabel } = input.itemCardControls || {};
  $ const { previous: buttonPrev, next: buttonNext } = itemCardNavigationAction || {};
  $ const { itemIndex = 0, itemsTotal = 1 } = input;

  <div data-testid="preview-item" class="preview-item" on-keydown("onKeyDownHandler")>
    <ebay-icon-button
      data-testid="preview-item-close"
      class="preview-item-action-close"
      aria-label=itemCardCloseAction?.accessibilityText
      ...getPropsForClickTracking(itemCardCloseAction?.trackingList)
      size="small"
      on-click("onCloseHandler")
    >
      <ebay-close-16-icon/>
    </ebay-icon-button>
    <div class="preview-item-image">
      <img src=image?.URL alt=(title?.textSpans?.[0].text)>
      <item-watchlist
        model=card
        watchInstance=watchInstance
        localizedContent=localizedContent
        handleWatchListItemToggle=handleWatchListItemToggle
        watchListItems=watchListItems
      />
    </div>
    <div class="preview-item-content">
      <if(hotnessSignal)>
        <hotness-signal model=hotnessSignal/>
      </if>
      <a
        target="_blank"
        rel="noreferrer"
        title=(title?.textSpans?.[0].text)
        href=action?.URL
        class="preview-item-title"
        ...getPropsForClickTracking(action?.trackingList)
      >
        <fe-textual-display model=title/>
      </a>
      <p class="preview-item-details">
        <fe-textual-display model=signalling/>
      </p>
      <item-seller-info locality=locality productRating=productRating sellerName=sellerName sellerRating=sellerRating/>
      <div class="preview-item-price">
        <item-price-display displayPrice=displayPrice listingFormat=listingFormat/>
      </div>
      <if(card.distance)>
        <div class="preview-item-distance" data-testid="preview-item-distance">
          <fe-textual-display model=card.distance/>
        </div>
      </if>
      <if(sponsored)>
        <div class="preview-item-sponsored-label">
          <fe-textual-display model=sponsored/>
        </div>
      </if>
    </div>
    <div class=[
      "preview-item-nav",
      {
        "preview-item-nav-hidden": itemsTotal < 2,
      },
    ]>
      <if(sellerListingCountLabel)>
        <div class="preview-item-count">
          <fe-textual-display model=itemCardLabel(sellerListingCountLabel, itemIndex, itemsTotal)/>
        </div>
      </if>
      <div class="preview-item-buttons">
        <ebay-icon-button
          size="small"
          disabled=itemIndex === 0
          aria-label=buttonPrev?.accessibilityText
          on-click("onPreviousItem")
          ...getPropsForClickTracking(buttonPrev?.trackingList)
        >
          <ebay-arrow-left-16-icon/>
        </ebay-icon-button>
        <ebay-icon-button
          size="small"
          disabled=itemIndex === itemsTotal - 1
          aria-label=buttonNext?.accessibilityText
          on-click("onNextItem")
          ...getPropsForClickTracking(buttonNext?.trackingList)
        >
          <ebay-arrow-right-16-icon/>
        </ebay-icon-button>
      </div>
    </div>
  </div>
</if>
